import { Injectable } from '@angular/core';
import { FlowMode } from '../dto/enum/flow.mode.enum';
import { FlowModeSubject } from '../subject/flow.mode.subject';

@Injectable({
    providedIn: 'root'
})
export class FlowService {
    constructor(private flowModeSubject: FlowModeSubject) {}

    private readonly steps: string[] = [
        'start',
        'segments',
        'nickname',
        'address',
        'maps',
        'papers',
        'second',
        'details-primary',
        'details-secondary',
        'pictures',
        'reviews',
        'tags',
        'third',
        'ad',
        'price',
        'success'
    ];

    /**
     * Retorna true si el modo actual permite avanzar automáticamente de etapa
     */
    shouldAdvanceStage(): boolean {
        return this.flowModeSubject.getCurrentMode() === FlowMode.CREATE;
    }

    /**
     * Devuelve el nombre del siguiente paso basado en el paso actual
     */
    getNextStep(currentPath: string): string {
        const index = this.steps.indexOf(currentPath);
        if (index !== -1 && index < this.steps.length - 1) {
            return `/${this.steps[index + 1]}`;
        }
        return '/success';
    }

    /**
     * Devuelve el nombre del paso anterior
     */
    getPreviousStep(currentPath: string): string {
        const index = this.steps.indexOf(currentPath);
        if (index > 0) {
            return `/${this.steps[index - 1]}`;
        }
        return '/segments';
    }

    /**
     * Devuelve el índice del paso actual en la lista
     */
    getStepIndex(step: string): number {
        return this.steps.indexOf(step);
    }

    /**
     * Devuelve el nombre del paso en el índice dado
     */
    getStepByIndex(index: number): string | null {
        return index >= 0 && index < this.steps.length ? this.steps[index] : null;
    }

    /**
     * Verifica si un paso es válido dentro del flujo
     */
    isStepValid(step: string): boolean {
        return this.steps.includes(step);
    }

    /**
     * Devuelve el primer paso del flujo
     */
    getFirstStep(): string {
        return this.steps[0];
    }

    /**
     * Devuelve el último paso del flujo
     */
    getLastStep(): string {
        return this.steps[this.steps.length - 1];
    }

    /**
     * Devuelve todos los pasos en orden
     */
    getAllSteps(): string[] {
        return [...this.steps];
    }
}
